module.exports = __webpack_public_path__ + "static/img/map.0397baca.png";